import { Component, h, Prop } from '@stencil/core';
import { Unsubscribe } from 'redux';
import { RootState } from '../../../redux/reducers';
import { store } from "../../../redux/store";
import { trans } from '../../../utils/trans';
import { ProcessingSpinnerContent } from '../../../redux/types';

@Component({
    tag: 'rentware-checkout-spinner',
    shadow: true,
})

export class RentwareCheckoutSpinner {
    @Prop({ mutable: true }) locale: string;
    @Prop({ mutable: true }) translations;
    @Prop({ mutable: true }) content: ProcessingSpinnerContent;

    unsubscribe!: Unsubscribe;

    componentWillLoad() {
        this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
            return {
                locale: state.app.locale,
                translations: state.system.translations,
                content: state.app.processingSpinnerContent,
            };
        });
    }

    disconnectedCallback() {
        this.unsubscribe();
    }

    get processingPaymentText() {
        return this.content?.text ?? trans('payment.processing', this.locale, this.translations);
    }

    get spinnerInfoText1() {
        return this.content?.text1 ?? trans('payment.processingInfo1', this.locale, this.translations)
    }

    get spinnerInfoText2() {
        return this.content?.text2 ?? trans('payment.processingInfo2', this.locale, this.translations)
    }

    render() {
        return (
            <rentware-spinner-3d
                text={this.processingPaymentText}
                info={"<p>" + this.spinnerInfoText1 + "<p/><p>" + this.spinnerInfoText2 + "</p>"}
            />
        );
    }
}
